import { Layout, Button, Menu, Dropdown } from "antd";
import { LogoutOutlined, UserOutlined } from "@ant-design/icons";
import { useEffect } from "react";
import { connect } from "react-redux";
import service from "../@services";

import MainContent from "./MainContent";
import MainMenu from "./MainMenu";
import MainBreadcrumb from "./MainBreadcrumb";
const { Header, Content, Sider } = Layout;
const MainLayout = ({ userInfo }) => {
  useEffect(() => {
    if (!userInfo) {
      service.auth.userInfo();
    }
  }, [userInfo]);
  return (
    <Layout style={{ height: "100%", textAlign: "left" }}>
      <Sider width={200} collapsible>
        <div style={{ padding: "20px 26px" }}>
          <img src="/assets/ERP@2x.png" style={{ width: "138px" }} />
        </div>
        <MainMenu />
      </Sider>
      <Layout>
        <Header style={{ backgroundColor: "white", padding: "20px 20px 0" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <MainBreadcrumb />
            <UserOperDropdown userInfo={userInfo} />
          </div>
        </Header>
        <Content
          style={{
            padding: 20,
            margin: 0,
            minHeight: 280,
            overflowY: "auto",
          }}
        >
          <MainContent />
        </Content>
      </Layout>
    </Layout>
  );
};
export default connect((state) => ({ userInfo: state.auth.userInfo }))(
  MainLayout
);

const UserOperDropdown = ({ userInfo }) => {
  const logout = () => {
    service.auth.logout();
  };
  const menu = (
    <Menu>
      <Menu.Item key="logout">
        <Button
          size="small"
          icon={<LogoutOutlined />}
          type="text"
          onClick={logout}
        >
          退出登录
        </Button>
      </Menu.Item>
    </Menu>
  );
  return (
    <Dropdown overlay={menu}>
      <Button icon={<UserOutlined />} size="small" type="text">
        {userInfo && userInfo.name}
      </Button>
    </Dropdown>
  );
};
